import { useT } from "@transifex/react";

interface AvatarProps {
    img: {
        src?: string;
        alt?: string;
    };
    sizeClasses: string;
    backgroundColor?: string;
    borderColor?: string;
    id?: string;
}

const Avatar = (props: AvatarProps) => {
    const t = useT();
    const t_userAvatar = t("User avatar", { _tags: "TeacherArea, Account, ScreenReaderOnly" });

    const baseClasses = "flex items-end justify-center rounded-circle transition-all duration-300 ease-in-out border";

    const wrapperClass = `${baseClasses} ${props.sizeClasses} ${props.backgroundColor} ${
        props.borderColor ?? "border-stone-300"
    }`;

    return (
        <div
            className={wrapperClass}
            id={props.id}
        >
            <img
                src={props.img?.src}
                alt={props.img?.alt || t_userAvatar}
                width="100%"
                height="100%"
            />
        </div>
    );
};

export default Avatar;
